/* RAKNIDA · assets/rk-art-fit.js — the whole artwork, always (8 Oct 2026).
   The shop app draws each print as an image inside a box sized to the listed paper ratio, with object-fit: cover. When a work's
   image is not exactly the listed ratio, cover trims its edges, so the white border, the mat and the frame appeared to cut into
   the artwork (galleries, Quick View, Preview on wall, Size scale, full screen). Contain shows the entire image, centred on its
   white sheet, as the register's border rule (§4.5) describes. Loaded by rk-pdps-help (product pages) and rk-shop-related (shop).
   Fold into the app's src/overrides.css at the next app build.
   9 Oct 2026 (DEC-419, page system §5a): switchable — window.RKX_UI.artFit false (theme editor, Page behaviour) leaves the app's
   own fit; missing keeps it on. */
(function () {
  if (window.__rkArtFit) return; window.__rkArtFit = true;
  if (window.RKX_UI && window.RKX_UI.artFit === false) return;
  var CSS = '#rk-shop-root .rk-sheet-img img{object-fit:contain!important}';
  function put(sr) {
    if (!sr || !sr.querySelector || sr.querySelector('style[data-rk-artfit]')) return;
    var s = document.createElement('style'); s.setAttribute('data-rk-artfit', '1'); s.textContent = CSS; sr.appendChild(s);
  }
  function scan() {
    put(window.__RK_SHADOW);
    document.querySelectorAll('iframe').forEach(function (f) { try { put(f.contentWindow && f.contentWindow.__RK_SHADOW); } catch (e) {} });
  }
  scan(); setInterval(scan, 1000);
})();
